<div class="app-select app-select--multiple" ngbDropdown #myDrop="ngbDropdown" (openChange)="onOpenChange($event)">
  <button
    class="app-select__toggle-button"
    [ngClass]="{ 'app-select__text--placeholder': !checkedItems }"
    ngbDropdownToggle
    name="{{ name }}"
    [disabled]="isDisabled"
    type="button"
  >
    {{ checkedItems ? 'Выбрано: ' + checkedItems : defaultText }}
  </button>
  <div ngbDropdownMenu>
    <div class="app-select__controls">
      <div class="controls__top">
        <a class="link link--dotted" (click)="toggleItemsChecked()">
          <span *ngIf="isAllItemsChecked">Сбросить все</span>
          <span *ngIf="!isAllItemsChecked">Выбрать все</span>
        </a>
        <a class="link link--dotted" (click)="changeInversion()">Инвертировать</a>
      </div>
      <div class="controls__bottom">
        <app-field>
          <content-prefix>
            <div class="field__input-prefix">
              <app-icon [glyph]="'search'" [size]="'16'" [color]="'gray-dark'"></app-icon>
            </div>
          </content-prefix>
          <input type="text" class="input-text input--prefix" [(ngModel)]="searchText" [ngModelOptions]="{ standalone: true }" (keyup)="searchText = $event.target.value" />
        </app-field>
        <div class="cur-pointer color-gray" (click)="toggleItemsShow()">
          <span *ngIf="isAllItemsShow">
            <app-icon [glyph]="'select-multiple-all'" [size]="'24'" title="Показать выбранные"></app-icon>
          </span>
          <span *ngIf="!isAllItemsShow">
            <app-icon [glyph]="'select-multiple-partial'" [size]="'24'" title="Показать все"></app-icon>
          </span>
        </div>
      </div>
    </div>
    <div class="app-select__list">
      <div *ngFor="let item of itemsClone | searchTextFilter: searchText : textKey; let index = index; let last = last" [ngClass]="{ 'mb-8': !last }">
        <ng-container *ngIf="isAllItemsShow || (!isAllItemsShow && item.checked)">
          <app-checkbox>
            <input type="checkbox" id="{{ 'checkbox_' + item[textKey] + '_' + index }}" (ngModelChange)="onChangeCheckedItem($event, item)" [(ngModel)]="item.checked" [ngModelOptions]="{ standalone: true }" />
            <checkbox-text>
              <span [innerHTML]="item[textKey] | highlightText: searchText"></span>
            </checkbox-text>
          </app-checkbox>
        </ng-container>
      </div>
    </div>
  </div>
</div>
